import React from 'react';  
import About from '../components/About.jsx';
const AboutPage = () => {
    return(
        <div>
            <About></About>
        </div>
    )
};
export default AboutPage;